import { VariaveisAmbiente } from "ambiente";
import { useApiBase } from "api/base";
import { useCallback } from "react";

export function useGetPessoas() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getPessoas = useCallback(
        (query: string, empresaId: string) => {
            return invocarApi({
                url: `api/v4/empresa/${empresaId}/pessoas${query}`,
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'Domain': 'app.touchone.com.br',
                },
                enviarTokenUsuario: false,
                baseURL: VariaveisAmbiente.masterApi,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        getPessoas,
    };
}